/* Hero · Carousel — sections/kkumi-hero-carousel.liquid.
   State: index, playing (the visitor's Play/Pause choice), elapsed (ms into the
   current slide). Hover/focus hold the clock without touching `playing`.
   All copy and timings arrive as data-* attributes on the root. */
(function () {
  function init(root) {
    if (!root || root.dataset.kkBound === '1') return;
    root.dataset.kkBound = '1';

    /* Clear the loading state (grey shimmer, held scrim + captions) once the
       first photo has painted — or failed, so the section never sticks. */
    var firstImg = root.querySelector('.hc__slide.is-active img');
    function ready() { root.removeAttribute('data-hc-pending'); }
    if (!firstImg || (firstImg.complete && firstImg.naturalWidth > 0)) ready();
    else { firstImg.addEventListener('load', ready, { once: true }); firstImg.addEventListener('error', ready, { once: true }); }

    var slides = [].slice.call(root.querySelectorAll('[data-hc-slide]'));
    var caps = [].slice.call(root.querySelectorAll('[data-hc-cap]'));
    var dots = [].slice.call(root.querySelectorAll('[data-hc-go]'));
    var play = root.querySelector('[data-hc-play]');
    var prog = root.querySelector('[data-hc-progress]');
    var count = slides.length;
    if (count < 2) return;

    var DUR = parseInt(root.getAttribute('data-interval-ms'), 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var holdOnHover = root.getAttribute('data-pause-on-hover') === 'true';

    var i = 0;
    var playing = autoplay;
    var held = false;
    var elapsed = 0;
    var last = performance.now();

    function paint() {
      /* Each slide carries its own scrim/text style; the shared controls follow
         the active slide's text colour. */
      var ctl = slides[i] && slides[i].getAttribute('data-controls');
      if (ctl) root.style.setProperty('--hc-controls', ctl);
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        if (n === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      /* Two caption stacks (copy, CTA) share the slide order. */
      caps.forEach(function (c, n) {
        var on = n % count === i;
        c.classList.toggle('is-active', on);
        if (on) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
        var a = c.querySelector('a');
        if (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    function go(n) {
      n = (n + count) % count;
      if (n === i) return;
      i = n;
      elapsed = 0;
      paint();
    }

    function setPlaying(p) {
      playing = p;
      if (play) {
        play.setAttribute('aria-pressed', p ? 'false' : 'true');
        play.setAttribute('aria-label', p ? root.getAttribute('data-pause-label') : root.getAttribute('data-play-label'));
      }
    }

    root.querySelectorAll('[data-hc-dir]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + parseInt(b.getAttribute('data-hc-dir'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hc-go'), 10)); });
    });
    if (play) play.addEventListener('click', function () { setPlaying(!playing); });

    if (holdOnHover) {
      root.addEventListener('mouseenter', function () { held = true; });
      root.addEventListener('mouseleave', function () { held = false; });
      root.addEventListener('focusin', function () { held = true; });
      root.addEventListener('focusout', function () { held = false; });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(i + 1);
      else if (e.key === 'ArrowLeft') go(i - 1);
    });

    /* Swipe on touch. */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1));
    }, { passive: true });

    function tick(now) {
      /* Clamp the step so a backgrounded tab doesn't skip a slide on return. */
      var dt = Math.min(now - last, 100);
      last = now;
      if (playing && !held) {
        elapsed += dt;
        if (elapsed >= DUR) go(i + 1);
      }
      if (prog) prog.style.transform = 'scaleX(' + Math.min(elapsed / DUR, 1) + ')';
      if (root.isConnected) requestAnimationFrame(tick);
    }

    /* Theme editor: jump to the block being edited. */
    root.closest('.shopify-section') && root.closest('.shopify-section').addEventListener('shopify:block:select', function (e) {
      var n = slides.indexOf(e.target.querySelector('[data-hc-slide]') || e.target);
      if (n > -1) { go(n); setPlaying(false); }
    });

    setPlaying(autoplay);
    paint();
    if (autoplay || prog) requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('[data-kk-hero-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
